import styled from 'styled-components';
import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormError,
  Heading,
} from '@alefeducation/ui-elements-library-core';
import { containerSpace } from '../AddEditMember/styled';
import EmailValidationInput from '../inputs/EmailValidationInput';
import {
  CHECK_EMAIL,
  PLEASE_ENTER_EMAIL,
  WRONG_EMAIL_FORMAT,
} from '../../utils/constants';
import { isEmailValid } from '../../utils/Validators';
import InfoMessage from '../InfoMessage';

const StyledCheckEmailContainer = styled.div`
  ${containerSpace};
  border-bottom: 5px solid ${({ theme }: any) => theme.colors.primary[10]};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: ${({ theme }: any) => `${theme.space[14]}px`};
`;

const StyledInputAction = styled.div`
  display: flex;
  column-gap: ${({ theme }: any) => `${theme.space[16]}px`};
`;

type Props = {
  messageText: string;
  email: string;
  disabled: boolean;
  onCheckEmail: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const CheckEmail = (props: Props) => {
  const { messageText, email, disabled, onCheckEmail, onChange } = props;
  const [errorMessage, setErrorMessage] = useState('');
  const hasError = errorMessage !== '';

  const checkEmail = () => {
    if (email === '') {
      setErrorMessage(PLEASE_ENTER_EMAIL);
    } else if (!isEmailValid(email)) {
      setErrorMessage(WRONG_EMAIL_FORMAT);
    } else {
      onCheckEmail();
    }
  };

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
    if (email !== '') {
      setErrorMessage('');
    }
  };

  return (
    <StyledCheckEmailContainer data-testid="admin-check-email">
      <StyledHeading
        variant="heading-small"
        data-testid={'please-enter-email-label'}
      >
        Please enter e-mail
      </StyledHeading>

      <FormControl appearance={hasError ? 'error' : 'regular'}>
        <StyledInputAction>
          <EmailValidationInput
            data-testid="admin-email"
            name="email"
            value={email}
            onChange={onEmailChange}
          />
          <Button
            disabled={disabled}
            variant="secondary"
            onClick={checkEmail}
            data-testid="check-email-button"
          >
            {CHECK_EMAIL}
          </Button>

          {messageText !== '' && <InfoMessage messageText={messageText} />}
        </StyledInputAction>

        {hasError && (
          <FormError data-testid="email-error-message">
            {errorMessage}
          </FormError>
        )}
      </FormControl>
    </StyledCheckEmailContainer>
  );
};

export default CheckEmail;
